module.exports = __webpack_public_path__ + "img/SamanKhanaqini.a46e2434.jpg";